import { service } from "./axios.js";

export const getadList = function (params) {
  return service.post("/open/ad/listAll", params);
};
